// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem3,
    GridItem5,
    GridItem7,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorTextMultiline,
} from '../../../business-components/TextValidator/TextValidator'

import {
    pesquisaDescricaoList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoFamiliarHistoricoSaudeFamiliaresList from '../../../business-rules/List/tipoFamiliarHistoricoSaudeFamiliaresList'

import simNaoList from '../../../business-rules/List/simNaoList'

import {
    IconButtonClearEntradaDados
 } from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
 } from '../../../business-components/Button/Button'

import {
    incrementaContFamiliar,
} from '../cadastro-form/CadastroServiceFamiliares'

import RiscosFormCondicaoSaude from './RiscosFormCondicaoSaude'

import {
    processaRegistrosDefaultIniciaisHistoricoSaudeFamiliares,
    processaAlteracaoHistoricoSaudeFamiliaresVivo,
} from './RiscosServiceHistoricoSaudeFamiliares'

const RiscosFormHistoricoSaudeFamiliares = ({ familiar, values, handleChange }) => {

    const nomeFamiliar = pesquisaDescricaoList(familiaresList(values), familiar)

    processaRegistrosDefaultIniciaisHistoricoSaudeFamiliares(values, familiar)

    return (
        <FieldArray name="historicoSaudeFamiliares">
            {(arrayHelpers) => (
                <CardGridEntradaDados>
                    <CardGridDivHeaderEntradaDados>
                        <CardGridDivEntradaDados>
                            {LABEL.historicoSaudeFamiliares + " " + nomeFamiliar}
                        </CardGridDivEntradaDados>
                    </CardGridDivHeaderEntradaDados>

                    <CardGridDivBodyEntradaDados>
                        <DivForm
                            style={{
                                display: values.historicoSaudeFamiliares && values.historicoSaudeFamiliares.filter(historicoSaudeFamiliares => historicoSaudeFamiliares.familiar === familiar).length > 0 ? "block" : "none"
                            }}
                        >
                            {values.historicoSaudeFamiliares?.map((item, ind) => {

                                return item.familiar === familiar ? (
                                    <GridContainer
                                        key={ind}
                                    >
                                        <GridItem12>
                                            <GridContainer>
                                                <GridItem3>
                                                    <TextFieldTextSelect
                                                        name={`historicoSaudeFamiliares[${ind}].tipoFamiliar`}
                                                        label={LABEL.tipoFamiliar}
                                                        value={item.tipoFamiliar || ''}
                                                        onChange={handleChange}
                                                        list={tipoFamiliarHistoricoSaudeFamiliaresList}
                                                    />
                                                </GridItem3>
                                                <GridItem5>
                                                    <TextValidatorText
                                                        name={`historicoSaudeFamiliares[${ind}].nomeFamiliar`}
                                                        label={LABEL.nome}
                                                        value={item.nomeFamiliar || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.nome}
                                                    />
                                                </GridItem5>
                                                <GridItem3>
                                                    <TextFieldTextSelect
                                                        name={`historicoSaudeFamiliares[${ind}].vivo`}
                                                        label={LABEL.vivo}
                                                        value={item.vivo || ''}
                                                        onChange={handleChange}
                                                        list={simNaoList}
                                                        onBlur={processaAlteracaoHistoricoSaudeFamiliaresVivo(item)}
                                                    />
                                                </GridItem3>
                                                <GridItem1>
                                                    <IconButtonClearEntradaDados
                                                        onClick={() =>
                                                            arrayHelpers.remove(ind)
                                                        }
                                                    />
                                                </GridItem1>
                                            </GridContainer>

                                            <GridContainer>
                                                <GridItem1 />

                                                <GridItem3
                                                    style={{
                                                        display: item.vivo === "S" 
                                                            ? "block"
                                                            : "none"
                                                    }}
                                                >
                                                    <TextValidatorNumber
                                                        name={`historicoSaudeFamiliares[${ind}].idadeFamiliar`}
                                                        label={LABEL.idade}
                                                        value={item.idadeFamiliar === 0 ? 0 : item.idadeFamiliar || ''}
                                                        onChange={handleChange}
                                                        numMin={NUMMIN.idade}
                                                        numMax={NUMMAX.idade}
                                                    />
                                                </GridItem3>
                                                <GridItem3
                                                    style={{
                                                        display: item.vivo === "N" 
                                                            ? "block"
                                                            : "none"
                                                    }}
                                                >
                                                    <TextValidatorNumber
                                                        name={`historicoSaudeFamiliares[${ind}].idadeObito`}
                                                        label={LABEL.idadeObito}
                                                        value={item.idadeObito || ''}
                                                        onChange={handleChange}
                                                        numMin={NUMMIN.idade}
                                                        numMax={NUMMAX.idade}
                                                    />
                                                </GridItem3>
                                                <GridItem7
                                                    style={{
                                                        display: item.vivo === "N" 
                                                            ? "block"
                                                            : "none"
                                                    }}
                                                >
                                                    <TextValidatorTextMultiline
                                                        name={`historicoSaudeFamiliares[${ind}].causaObito`}
                                                        label={LABEL.causaObito}
                                                        value={item.causaObito || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.causaObito}
                                                    />
                                                </GridItem7>
                                            </GridContainer>

                                            <DivForm
                                                style={{
                                                    display: item.vivo === "S" 
                                                        ? "block"
                                                        : "none"
                                                }}
                                            >
                                                <RiscosFormCondicaoSaude
                                                    familiar={item.familiarHistoricoSaudeFamiliares}
                                                    values={values}
                                                    handleChange={handleChange}
                                                />

                                                <CardGridDividerElementos/>
                                            </DivForm>
                                        </GridItem12>
                                    </GridContainer>
                                )
                                : 
                                (
                                    <DivForm
                                        key={ind}
                                    />
                                )
                            })}
                        </DivForm>

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirHistoricoSaudeFamiliares} 
                            onClick={() => 
                                {
                                    incrementaContFamiliar(values)
                                    arrayHelpers.push({
                                        familiar: familiar,
                                        familiarHistoricoSaudeFamiliares: values.contFamiliar,
                                    })
                                }
                            }
                        />



                    </CardGridDivBodyEntradaDados>
                </CardGridEntradaDados>
            )}
        </FieldArray>
    )
}

export default RiscosFormHistoricoSaudeFamiliares